import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DatePipe, NgIf} from "@angular/common";
import { TranslateModule } from '@ngx-translate/core';
import {CompanyPlan, ExpertPlan} from "../../../../../constants/subscription-variables";

@Component({
  selector: 'tl-cancel-subscription-modal',
  standalone: true,
  imports: [
    TranslateModule,
    DatePipe
  ],
  templateUrl: './cancel-subscription-modal.component.html',
})
export class CancelSubscriptionModalComponent {
  @Input() currentPlan: any;
  @Input() confirmBtnText = '';
  @Output() cancelModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() confirmModal: EventEmitter<void> = new EventEmitter<void>();
  protected readonly ExpertPlan = ExpertPlan;
  protected readonly CompanyPlan = CompanyPlan;
}
